import grpc from '@/api/request'
import { kpNotice } from '@/util/notice'
import {randomn} from '@/lib/utils'

function corpList(params) {
  let request = {
    phone: sessionStorage.accountPhone,
    email: sessionStorage.accountEmail
  }
  grpc.call('/corp/corporation/invite/register/query', request)
    .then(response => {
      if (response.code === 0) {
        params.callback(response)
      } else {
        kpNotice.warning('middle', 2000, response.code + response.msg + response.requestId)
      }
    })
    .catch(error => {
      params.errorback(error)
      kpNotice.warning('middle', 2000, error)
    })
}
function registCorp(params) {
  let request = {
    clueId: params.clueId,
    assignedAgentId: localStorage.agentId,
    cityId: params.cityId,
    corpAddress: params.corpAddress,
    corpAdminName: params.corpAdminName,
    corpName: params.corpName,
    corpRegisterOrigin: 2,
    corpType: params.corpType,
    countryId: params.countryId,
    creatorAgentId: localStorage.agentId,
    currencyId: 'CNY',
    districtId: params.districtId,
    email: params.email,
    followAgentStaffId: localStorage.getASIByUrl,
    industry1Id: params.industry1Id,
    industry2Id: params.industry2Id,
    phone: params.phone,
    provinceId: params.provinceId,
    sellerAgentStaffId: localStorage.getASIByUrl,
    sysSequence: new Date().getTime().toString() + randomn(6),
    timeZoneId: 'Asia/Shanghai',
    storeImages: params.storeImages,
    mainIndustryId: params.mainIndustryId,
    secondIndustryId1: params.secondIndustryId1 || '',
    secondIndustryId2: params.secondIndustryId2 || '',
    corpVersion1: params.corpVersion1,
    corpPlugin: params.corpPlugin
  }
  grpc.call('/third/corporation/register', request)
    .then(response => {
      if (response.code === 0) {
        params.callback(response)
      } else {
        console.log('corp.js error:' + response.code)
        params.errorback(response)
        kpNotice.warning('middle', 5000, response.code + response.msg + response.requestId)
      }
    })
    .catch(error => {
      console.log('corp.js catch error:')
      params.errorback(error)
      kpNotice.warning('middle', 5000, error.msg + '(' + error.requestId + ')')
    })
}

export {
  corpList,
  registCorp
}



// WEBPACK FOOTER //
// ./src/controller/corp.js